import { cn } from "../utils/styling";
import { Icon } from "./Icon";

export const SecondaryNavLink = ({ children, className, isActive, isDisabled, onClick }) => {
  return (
    <button
      className={cn(
        "flex w-full items-center justify-between gap-ds-1x text-left outline-none font-ds-body-regular-lg",
        "rounded-ds-0-25x border-2 border-transparent pl-ds-0-75x pr-ds-0-5x",
        !isActive && !isDisabled && "bg-transparent text-lds-foreground-brand",
        isActive && !isDisabled && "bg-lds-element-primary text-lds-foreground-inverse",
        !isDisabled && !isActive && "enabled:hover:bg-lds-selection-subtle",
        !isDisabled && isActive && "enabled:hover:bg-lds-element-primary",
        !isDisabled &&
          !isActive &&
          "focus-visible:bg-lds-selection-subtle focus-visible:text-lds-element-primary focus-visible:border-ds-focus-thick",
        !isDisabled &&
          isActive &&
          "focus-visible:bg-lds-element-primary focus-visible:text-lds-foreground-inverse focus-visible:border-ds-focus-thick",
        isDisabled && "cursor-not-allowed bg-transparent text-lds-element-disabled-on",
        className
      )}
      disabled={isDisabled}
      onClick={(event) => {
        event.currentTarget.blur();
        onClick?.(event);
      }}
      type="button"
    >
      <span className="first-letter:uppercase">{children}</span>
      {isActive ? <Icon color="currentColor" iconName="ChevronRight" size="md" /> : null}
    </button>
  );
};
